import MathHelper from "../../utils/MathHelper";
import { DateTime } from "luxon";
import DateAndValue from "../DateAndValue";

export default class ForecastedDOE {
  constructor({
    source = "Survey",
    method = "Linear",
    yearsFormatted = [],
    DOE = [],
    growthRate = 0,
    manualValue = 0,
    weights = yearsFormatted.map((year) => ({ date: year, value: 1 })),
    analystNote = "",
  }) {
    this.source = source;
    this.method = method;
    this.yearsFormatted = yearsFormatted;
    this.DOE = DOE;
    this.growthRate = growthRate;
    this.manualValue = manualValue;
    this.weights = weights;
    this.analystNote = analystNote;
  }

  get DOEArray() {
    return [...this.DOE.map((obj) => obj.value)];
  }

  get yearsTotal() {
    const { yearsFormatted } = this;
    let yearsTotal = [...yearsFormatted];
    let forecastYear = new Date(yearsFormatted[yearsFormatted.length - 1]);     //latest value of yearsFormatted
    forecastYear = DateTime.fromJSDate(new Date(forecastYear)).plus({ years: 1 }).toFormat("LLLL y");    //get forecast year
    yearsTotal.push(forecastYear);
    return yearsTotal;
  }

  get linearValue() {
    return MathHelper.calculateLinearTrend(
      DateTime.fromJSDate(new Date(this.yearsTotal[this.yearsTotal.length - 1])).year,
      this.DOEArray,
      this.yearsFormatted.map((item) => DateTime.fromJSDate(new Date(item)).year)
    )
  }

  get weightsValue() {
    const { DOE, weights } = this;
    return this.getArrayMultiply(DOE, weights).reduce((acc, obj) => acc + obj.value, 0) /
      weights.reduce((acc, obj) => acc + obj.value, 0);
  }

  get exponentialValue() {
    return Math.exp(MathHelper.calculateLinearTrend(
      DateTime.fromJSDate(new Date(this.yearsTotal[this.yearsTotal.length - 1])).year,
      this.DOEArray.map((val) => Math.log(val)),
      this.yearsFormatted.map((item) => DateTime.fromJSDate(new Date(item)).year)
    ))
  }

  get forecastedValue() {
    return this[this.method.toLowerCase() + "Value"];
  }

  get forecastedDOE() {
    return Number(this.forecastedValue) * (1 + Number(this.growthRate));
  }

  get yoyArray() {
    const { DOEArray, forecastedValue } = this;
    let estimateArray = DOEArray.concat([forecastedValue]);
    return estimateArray.map((val, index) => {
      if(index === 0) return null;
      else return ((val - estimateArray[index - 1]) / estimateArray[index - 1] * 100).toFixed(2);
    })
  }

  get minYaxis() {
    //this is used to make the chart prettier, giving the minimum level of y axis
    const { DOEArray } = this;
    return Math.min(...DOEArray) - (Math.max(...DOEArray) - Math.min(...DOEArray)) / 2
  }

  getArrayMultiply(array1, array2) {
    //multiply elements of arrays
    return this.yearsFormatted.map(
      (year, index) =>
        new DateAndValue({
          date: year,
          value: array1[index].value * array2[index].value,
        })
    );
  }
}